import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "@/constants";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

interface PremiumContentProps {
  onClose?: () => void;
  isModal?: boolean;
}

const PremiumContent: React.FC<PremiumContentProps> = ({ onClose, isModal = false }) => {
  const navigate = useNavigate();

  const handleUpgrade = () => {
    if (onClose) onClose();
    navigate(ROUTES.UPGRADE);
  };

  return (
    <Paper
      elevation={0}
      sx={{
        p: isModal ? { xs: 2, md: 4 } : { xs: 4, md: 8 },
        textAlign: "center",
        borderRadius: "24px",
        background: isModal ? "white" : "linear-gradient(135deg, #F0F9F8 0%, #FFFFFF 100%)",
        border: isModal ? "none" : "1px solid #E5E7EB",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: "24px",
        boxShadow: isModal ? "none" : "0 10px 40px rgba(42, 157, 143, 0.05)",
      }}
    >
      <Box
        sx={{
          width: "80px",
          height: "80px",
          borderRadius: "20px",
          backgroundColor: "#E0F2FE",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "relative",
          mb: 2,
        }}
      >
        <LockOutlinedIcon sx={{ fontSize: "40px", color: "#0284C7" }} />
        <Box
          sx={{
            position: "absolute",
            top: "-10px",
            right: "-10px",
            backgroundColor: "#FFC107",
            borderRadius: "50%",
            p: "6px",
            border: "4px solid white",
            display: "flex",
          }}
        >
          <RocketLaunchIcon sx={{ fontSize: "16px", color: "#000" }} />
        </Box>
      </Box>

      <Box>
        <Typography
          variant="h4"
          sx={{
            fontWeight: "800",
            color: "#1F2937",
            mb: 1.5,
            fontSize: isModal ? { xs: "20px", md: "26px" } : { xs: "24px", md: "32px" },
          }}
        >
          Nâng cấp Premium
        </Typography>
        <Typography
          sx={{
            color: "#6B7280",
            fontSize: "16px",
            maxWidth: "400px",
            mx: "auto",
            lineHeight: 1.6,
          }}
        >
          Tính năng này chỉ dành riêng cho thành viên **PRO**. Hãy nâng cấp gói cước để mở khóa lộ trình học cá nhân hóa
          và các công cụ luyện nói đỉnh cao.
        </Typography>
      </Box>

      <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2, width: "100%", maxWidth: "300px" }}>
        <Button
          variant="contained"
          size="large"
          fullWidth
          onClick={handleUpgrade}
          sx={{
            py: 1.5,
            borderRadius: "12px",
            fontSize: "16px",
            fontWeight: "700",
            textTransform: "none",
            backgroundColor: "#2A9D8F",
            boxShadow: "0 4px 14px rgba(42, 157, 143, 0.3)",
            "&:hover": {
              backgroundColor: "#264653",
            },
          }}
        >
          Nâng cấp ngay
        </Button>
        {!isModal && (
          <Button
            variant="text"
            onClick={() => navigate("/")}
            sx={{
              color: "#6B7280",
              textTransform: "none",
              fontSize: "14px",
              fontWeight: "500",
            }}
          >
            Quay lại trang chủ
          </Button>
        )}
      </Box>
    </Paper>
  );
};

export default PremiumContent;
